import { Controller } from "@hotwired/stimulus"

// Instant client-side search over a data table: types filter rows whose
// data-search-text includes the query, no server round trip.
export default class extends Controller {
  static targets = ["input", "row", "count"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visible = 0

    this.rowTargets.forEach((row) => {
      const matches = query.length === 0 || (row.dataset.searchText || "").includes(query)
      row.classList.toggle("hidden", !matches)
      if (matches) visible += 1
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = visible
    }
  }
}
